import { useState } from 'react'

export default function TruncateText({
  text,
  sliceVal,
  className,
}: {
  text: string
  sliceVal: number
  className?: string
}) {
  const [readMore, setReadMore] = useState(false)
  return (
    <p className={className}>
      {readMore ? (
        <span className={className}>{text}</span>
      ) : (
        <span className={className}>
          <span>
            {text.length <= sliceVal ? text : `${text.slice(0, sliceVal)}...`}{' '}
          </span>
          {text.length > sliceVal && (
            <span
              className="text-brand-blue-azureRadiance cursor-pointer text-sm"
              onClick={() => setReadMore(true)}
            >
              Read more
            </span>
          )}
        </span>
      )}
    </p>
  )
}
